import { c as _c } from "react/compiler-runtime";
import { useLayoutEffect } from "react";
import { pythonRunner } from "#/features/codeRunner/lib/pythonRunner";

/** Release Pyodide when playground hides or unmounts (Activity / cacheComponents). */
export const usePlaygroundRuntimeRelease = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useLayoutEffect(_temp2, t0);
};
function _temp() {
  return pythonRunner.release();
}
function _temp2() {
  return _temp;
}